import { render } from "./EditStore.vue?vue&type=template&id=79a56a2d&scoped=true&ts=true"
import script from "./EditStore.vue?vue&type=script&lang=ts"
export * from "./EditStore.vue?vue&type=script&lang=ts"

import "./EditStore.vue?vue&type=style&index=0&id=79a56a2d&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a56a2d"]])

export default __exports__